// extracted by mini-css-extract-plugin
export default {"label":"styles_label__lHXPm","checkbox_container":"styles_checkbox_container__QqLd9","checkbox":"styles_checkbox__i1Hfe","icon":"styles_icon__KjRZi"};